//auth
export const LOGIN = '/auth/login';
export const LOGOUT = '/auth/logout';
export const CHANGE_PASSWORD = '/auth/change-password';
